// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.timelineFlex_wTLFy {
  flex: 1 0;
  overflow: visible;
}
.timelineScrubberLabel_oCl7z {
  flex: 0 1 150px;
}

.playheadParent_OO7IM {
  position: relative;
  overflow: visible;
  cursor: pointer;
}

.playheadParent_OO7IM.loading_nJbv5 {
  cursor: progress;
}

.seekhead_hw9Dg, .playhead_Uhq2e {
  --icon-size-ratio: 0.4;
  --icon-width: calc(26px * var(--icon-size-ratio));
  --icon-height: calc(34px * var(--icon-size-ratio));
  background-image: url("https://storage.googleapis.com/molten-ui-assets/timeline/playhead.png");
  background-repeat: no-repeat;
  height: var(--icon-height);
  width: var(--icon-width);
  position: absolute;
  background-size: contain;
  top: -2px;
  left: calc(0% - var(--icon-width) / 2);
  pointer-events: none;
}

.playhead_Uhq2e {
  left: calc( var(--playhead-left, 0) - (var(--icon-width) / 2) );
  z-index: 1;
}

.playhead_Uhq2e::after {
  display: inline-block;
  border-left: 1px solid #194EDC;
  height: var(--timeline-stage-height);
  content: "";
  position: absolute;
  left: calc(50% - 0.5px);
}

.playhead_Uhq2e.loading_nJbv5::after {
  display: none;
}

.seekhead_hw9Dg::after {
  display: inline-block;
  border-left: 1px solid #194EDC;
  height: var(--timeline-stage-height);
  content: "";
  position: absolute;
  left: calc(50% - 0.5px);
}

.seekhead_hw9Dg {
  filter: opacity(70%);
  left: calc( var(--seekhead-left, 0) - (var(--icon-width) / 2) );
}

.seekhead_hw9Dg.playing_REnQ2 {
  filter: grayscale() opacity(20%);
}

.playhead_Uhq2e.loading_nJbv5 {
  --icon-max-dimension: calc(max(var(--icon-height), var(--icon-width)));
  background-image: url("https://storage.googleapis.com/molten-ui-assets/timeline/loading-regular.png");
  height: var(--icon-max-dimension);
  width: var(--icon-max-dimension);
  top: -4px;
}

.seekhead_hw9Dg.loading_nJbv5 {
  display: none;
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/api-ui-rsrc-management/lib/dataViewers/timeline/TimelineScrubber.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,iDAAiD;EACjD,kDAAkD;EAClD,8FAA8F;EAC9F,4BAA4B;EAC5B,0BAA0B;EAC1B,wBAAwB;EACxB,kBAAkB;EAClB,wBAAwB;EACxB,SAAS;EACT,sCAAsC;EACtC,oBAAoB;AACtB;;AAEA;EACE,+DAA+D;EAC/D,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,8BAA8B;EAC9B,oCAAoC;EACpC,WAAW;EACX,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,8BAA8B;EAC9B,oCAAoC;EACpC,WAAW;EACX,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,+DAA+D;AACjE;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,sEAAsE;EACtE,qGAAqG;EACrG,iCAAiC;EACjC,gCAAgC;EAChC,SAAS;AACX;;AAEA;EACE,aAAa;AACf","sourcesContent":[".timelineFlex {\n  flex: 1 0;\n  overflow: visible;\n}\n.timelineScrubberLabel {\n  flex: 0 1 150px;\n}\n\n.playheadParent {\n  position: relative;\n  overflow: visible;\n  cursor: pointer;\n}\n\n.playheadParent.loading {\n  cursor: progress;\n}\n\n.seekhead, .playhead {\n  --icon-size-ratio: 0.4;\n  --icon-width: calc(26px * var(--icon-size-ratio));\n  --icon-height: calc(34px * var(--icon-size-ratio));\n  background-image: url(\"https://storage.googleapis.com/molten-ui-assets/timeline/playhead.png\");\n  background-repeat: no-repeat;\n  height: var(--icon-height);\n  width: var(--icon-width);\n  position: absolute;\n  background-size: contain;\n  top: -2px;\n  left: calc(0% - var(--icon-width) / 2);\n  pointer-events: none;\n}\n\n.playhead {\n  left: calc( var(--playhead-left, 0) - (var(--icon-width) / 2) );\n  z-index: 1;\n}\n\n.playhead::after {\n  display: inline-block;\n  border-left: 1px solid #194EDC;\n  height: var(--timeline-stage-height);\n  content: \"\";\n  position: absolute;\n  left: calc(50% - 0.5px);\n}\n\n.playhead.loading::after {\n  display: none;\n}\n\n.seekhead::after {\n  display: inline-block;\n  border-left: 1px solid #194EDC;\n  height: var(--timeline-stage-height);\n  content: \"\";\n  position: absolute;\n  left: calc(50% - 0.5px);\n}\n\n.seekhead {\n  filter: opacity(70%);\n  left: calc( var(--seekhead-left, 0) - (var(--icon-width) / 2) );\n}\n\n.seekhead.playing {\n  filter: grayscale() opacity(20%);\n}\n\n.playhead.loading {\n  --icon-max-dimension: calc(max(var(--icon-height), var(--icon-width)));\n  background-image: url(\"https://storage.googleapis.com/molten-ui-assets/timeline/loading-regular.png\");\n  height: var(--icon-max-dimension);\n  width: var(--icon-max-dimension);\n  top: -4px;\n}\n\n.seekhead.loading {\n  display: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"timelineFlex": `timelineFlex_wTLFy`,
	"timelineScrubberLabel": `timelineScrubberLabel_oCl7z`,
	"playheadParent": `playheadParent_OO7IM`,
	"loading": `loading_nJbv5`,
	"seekhead": `seekhead_hw9Dg`,
	"playhead": `playhead_Uhq2e`,
	"playing": `playing_REnQ2`
};
export default ___CSS_LOADER_EXPORT___;
